import {
  Box,
  Divider,
  Grid,
  styled,
  Typography,
  Container,
  IconButton,
} from "@mui/material";
import http from "config/http";
import useIsMobileView from "hooks/useIsMobileView";
import useNotify from "hooks/useNotify";
import { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { GetDocumentLatest } from "store/api/rules";

function Help() {
  const [helpData, setHelpData] = useState();
  const navigate = useNavigate();
  const notify = useNotify();
  const params = useParams();
  const Id = +params?.id;
  const isMobileView = useIsMobileView();

  const getDocumentLatest = async () => {
    try {
      const { data } = await http.get(GetDocumentLatest(Id));
      setHelpData(data.data);
    } catch (error) {
      notify(error?.response?.data?.message, "error");
    }
  };

  useEffect(() => {
    getDocumentLatest();
    // eslint-disable-next-line
  }, [Id]);

  const help = {
    15: "سوالات متداول",
    11: "راهنما مبادله",
    12: "راهنما سفارش",
    13: "راهنما برداشت",
    14: "راهنما وام",
    16: "راهنما سرمایه‌گذاری",
  }[Id];

  return (
    <Container>
      {isMobileView && (
        <Grid container spacing={2} mb={2}>
          <Grid item md={6} xs={12}>
            <IconButtonStyle
              onClick={() => {
                navigate(-1);
              }}
            >
              <ion-icon name="chevron-back-outline" />

              <Typography variant="subtitle1" color="text.main">
                {help}
              </Typography>
            </IconButtonStyle>
          </Grid>
        </Grid>
      )}

      <Grid container spacing={2} mb={2}>
        <Grid item md={6} xs={12}>
          <Box
            display="flex"
            justifyContent={isMobileView ? "space-between" : ""}
          >
            <Box display="flex" pr={2}>
              <Typography color="text.main" variant="h6">
                {helpData?.version}
              </Typography>

              <Typography color="text.secondary" pl={1}>
                نسخه
              </Typography>
            </Box>

            <BoxHeader pr={2}>
              <Typography color="text.main" variant="h6">
                {helpData?.time}
              </Typography>

              <ion-icon name="time-outline" />
            </BoxHeader>

            <BoxHeader>
              <Typography color="text.main" variant="h6">
                {helpData?.date}
              </Typography>

              <ion-icon name="today-outline" />
            </BoxHeader>
          </Box>
        </Grid>

        {!isMobileView && (
          <Grid item xs={6} textAlign="right">
            <Typography variant="h3" color="text.main" fontWeight={700}>
              {help}
            </Typography>
          </Grid>
        )}
      </Grid>

      <Divider />

      <Grid container px={2}>
        <Grid item xs={12}>
          <Box>
            <BoxText dangerouslySetInnerHTML={{ __html: helpData?.text }} />
          </Box>
        </Grid>
      </Grid>
    </Container>
  );
}
const BoxHeader = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  "ion-icon": {
    paddingLeft: theme.spacing(1),
    color: theme.palette.text.secondary,
    fontSize: "20px",
  },
}));

const BoxText = styled(Box)(({ theme }) => ({
  color: theme.palette.text.main,
}));

const IconButtonStyle = styled(IconButton)(({ theme }) => ({
  "ion-icon": {
    paddingRight: theme.spacing(1),
    color: theme.palette.text.main,
    fontSize: "14px",
  },
}));

export default Help;
